import moment from "moment"

function timeLimitExceeded(lastSeenTime) {
    
    if (!lastSeenTime) {
        return true
    }
    const lastSeen = new moment(lastSeenTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
    const now = new moment()
    lastSeen.add(30, 'm')
    return lastSeen.isBefore(now)

}

function getScheduleDeviationClass(v, classRules) {
    
    if (
        !classRules ||
        timeLimitExceeded(v.properties.lastSeenTime)
    )
        return null

    // Check that realtimeStatus is available, but blocksequence is NULL
    if( v.properties.realtimeStatus && !v.properties.blockSequence )
        return null
    
    // Check that realtimeStatus is no_gps
    if( v.properties.realtimeStatus && v.properties.realtimeStatus == "no_gps" ) {
        return null
    }

    if (v.properties.deviation == null ) {
        return null
    }

    const devi = v.properties.deviation / 1000
    let returnClass = null
    for (let i = 0; i < classRules.length; i++) {
        const c = classRules[i]
        let min,
            max = null
        min = c.minval
        max = c.maxval

        if (min == null) {
            min = -999999999
        }
        if (max == null) {
            max = 9999999999
        }

        if (devi >= min && devi <= max) {
            returnClass = c['class']
            break
        }
    }
    return returnClass
}




export default {
    getScheduleDeviationClass,
}